import en from "./locales/en";
import ar from "./locales/ar";
import tr from "./locales/tr";
import uk from "./locales/uk";
import prs from "./locales/prs";
import sq from "./locales/sq";
import fr from "./locales/fr";
import pt from "./locales/pt";

import enUS from "antd/locale/en_US";
import arEG from "antd/locale/ar_EG";
import trTR from "antd/locale/tr_TR";
import ukUA from "antd/locale/uk_UA";
import faIR from "antd/locale/fa_IR";
import frFR from "antd/locale/fr_FR";
import ptPT from "antd/locale/pt_PT";

// Reuses the flag SVGs already bundled in public/media/svg/flags (same set
// the old Metronic language dropdown drew from) instead of adding new assets.
const flagUrl = (fileName) => `${process.env.PUBLIC_URL}/media/svg/flags/${fileName}`;

// Single source of truth for every language the platform supports. To add a
// new country/language: create locales/<code>.js exporting a flat
// { "English source string": "Translated string" } dictionary (see ar.js),
// then add one entry below — the language dropdown and LanguageProvider pick
// it up automatically, nothing else needs to change.
//
// Chosen to match the platform's existing country deployments under
// src/app/pages/auth/: Turkey, Afghanistan (Dari — the more widely used of
// its two official languages), Kosovo (Albanian). Sudan/Yemen/Syria are
// already covered by Arabic. Ukrainian, French, and Portuguese were added on
// request even though there's no matching country-specific deployment yet.
//
// `antdLocale` feeds antd's own <ConfigProvider locale={...}> (wired in
// LanguageContext.js), which translates antd's OWN built-in chrome — Table
// pagination ("Items / page", "Go to", empty-state text), DatePicker,
// Popconfirm OK/Cancel, etc. — separately from our own `dictionary` above,
// which only covers text we wrote ourselves. antd ships no Albanian pack, and
// nothing dedicated to Dari, so sq falls back to antd's English default and
// prs borrows Persian (fa_IR) — same script/grammar family, closest match.
export const LANGUAGES = [
   {
      code: "en",
      label: "English",
      dir: "ltr",
      flag: flagUrl("226-united-states.svg"),
      dictionary: en,
      antdLocale: enUS
   },
   {
      code: "ar",
      label: "العربية",
      dir: "rtl",
      flag: flagUrl("008-saudi-arabia.svg"),
      dictionary: ar,
      antdLocale: arEG
   },
   {
      code: "tr",
      label: "Türkçe",
      dir: "ltr",
      flag: flagUrl("006-turkey.svg"),
      dictionary: tr,
      antdLocale: trTR
   },
   {
      code: "uk",
      label: "Українська",
      dir: "ltr",
      flag: flagUrl("145-ukraine.svg"),
      dictionary: uk,
      antdLocale: ukUA
   },
   {
      code: "prs",
      label: "دری",
      dir: "rtl",
      flag: flagUrl("111-afghanistan.svg"),
      dictionary: prs,
      antdLocale: faIR
   },
   {
      code: "sq",
      label: "Shqip",
      dir: "ltr",
      flag: flagUrl("052-kosovo.svg"),
      dictionary: sq,
      antdLocale: enUS
   },
   {
      code: "fr",
      label: "Français",
      dir: "ltr",
      flag: flagUrl("195-france.svg"),
      dictionary: fr,
      antdLocale: frFR
   },
   {
      code: "pt",
      label: "Português",
      dir: "ltr",
      flag: flagUrl("224-portugal.svg"),
      dictionary: pt,
      antdLocale: ptPT
   }
];

export const DEFAULT_LANGUAGE_CODE = "en";
